import React, { useState } from 'react';

import { styled } from '../theme';
import { CommonComponentProps } from '../types/components';
import { FlexRow, SvgIcon } from './index';

const Container = styled('section')(({ theme }) => ({
    background: theme.color.white,
    display: 'flex',
    flexFlow: 'column',
    width: '100%',

    padding: '0 15px 15px 15px',
    [theme.breakpoint.md]: {
        padding: '0 30px 50px 30px',
    },
}));

const ContentWrapper = styled('div')<{ isCollapsed: boolean }>(({ theme, isCollapsed }) => ({
    background: theme.color.white,
    display: 'flex',
    flexFlow: 'column',
    width: '100%',

    height: isCollapsed ? 90 : 'auto',
    overflowY: isCollapsed ? 'hidden' : 'visible',
}));

const CollapseBtn = styled(FlexRow)(({ theme }) => ({
    cursor: 'pointer',
    height: 60,
    width: 'calc(100% + 30px)',
    marginBottom: -15,
    marginLeft: -15,

    color: theme.color.gray40,
    ':hover': {
        color: theme.color.green1,
    },

    [theme.breakpoint.md]: {
        height: 80,
        width: 'calc(100% + 60px)',
        marginBottom: -50,
        marginLeft: -30,
    },
}));

type SectionBodyProps = {
    isCollapsible?: boolean;
    isCollapsedInitially?: boolean;
} & CommonComponentProps;

const SectionBody: React.FC = ({
    children,
    isCollapsible,
    isCollapsedInitially,
    ...props
}: SectionBodyProps) => {
    const [isCollapsed, setCollapsed] = useState(!!(isCollapsible && isCollapsedInitially));

    const toggleCollapse = () => {
        setCollapsed(!isCollapsed);
    };

    const iconSrc = isCollapsed ? '/icons/ic-arrow-down.svg' : '/icons/ic-arrow-up.svg';

    return (
        <Container {...props}>
            <ContentWrapper isCollapsed={isCollapsed}>{children}</ContentWrapper>
            {!!isCollapsible && (
                <CollapseBtn onClick={toggleCollapse} justify="center" align="center">
                    <SvgIcon src={iconSrc} size="large" />
                </CollapseBtn>
            )}
        </Container>
    );
};

export default SectionBody;
